<!-- YES_NO_MISSIONS -->
<span *ngIf="answer === 'YES_NO_MISSIONS'">
    {{ 'global.staffing-result-answer-icons.yes-no-missions-icon' | translate }}
    {{ 'staffing-result.answer.yes-no-missions' | translate }}
</span>

<!-- YES -->
<span *ngIf="answer === 'YES'">
    {{ 'global.staffing-result-answer-icons.yes-icon' | translate }}
    {{ 'staffing-result.answer.yes' | translate }}
</span>

<!-- YES_DATE_CHANGED -->
<span *ngIf="answer === 'YES_DATE_CHANGED'">
    {{
        'global.staffing-result-answer-icons.yes-date-changed-icon' | translate
    }}
    {{ 'staffing-result.answer.yes-date-changed' | translate }}
</span>

<!-- YES_NOT_READY -->
<span *ngIf="answer === 'YES_NOT_READY'">
    {{ 'global.staffing-result-answer-icons.yes-not-ready-icon' | translate }}
    {{ 'staffing-result.answer.yes-not-ready' | translate }}
</span>

<!-- NO_CLIENT_CONSTRAINT -->
<span *ngIf="answer === 'NO_CLIENT_CONSTRAINT'">
    {{
        'global.staffing-result-answer-icons.no-client-constraint-icon'
            | translate
    }}
    {{ 'staffing-result.answer.no-client-constraint' | translate }}
</span>

<!-- NO_WRONG_TRAINING -->
<span *ngIf="answer === 'NO_WRONG_TRAINING'">
    {{
        'global.staffing-result-answer-icons.no-wrong-training-icon' | translate
    }}
    {{ 'staffing-result.answer.no-wrong-training' | translate }}
</span>

<!-- NO -->
<span *ngIf="answer === 'NO'">
    {{ 'global.staffing-result-answer-icons.no-icon' | translate }}
    {{ 'staffing-result.answer.no' | translate }}
</span>
<!-- NO_TOO_FAR -->
<span *ngIf="answer === 'NO_TOO_FAR'">
  {{'global.staffing-result-answer-icons.no-too-far-icon' | translate}}
  {{'staffing-result.answer.no-too-far' | translate}}
</span>

<!-- ...Not defined, no answer yet -->
<i *ngIf="!answer" class="fa fa-circle-thin" aria-hidden="true"></i>



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/result/answer/staffing-result-answer.component.html